import React from 'react';
import { get } from 'lodash';

import MenuItem from '../components/MenuItem/MenuItem';

import hasAccess, { resetBoardAccessId, resetGIRAccessId, resetNotificationsAccessId, resetPWB1AccessId } from '../services/HasAccess';
import uiLabelsPaths from '../services/uiFieldLabelsDictionary';

export const RESET = 'Board Reset';
export const EXTERNAL_RESET = 'PWB1 Reset';
export const FIRMWARE_UPDATE_LABEL = 'FW Update';
export const GIR_RESET = 'GIR Reset';
export const NOTIFICATION_RESET = 'Notification Reset';

export const RESET_COMMAND = 'RESET';
export const EXTERNAL_RESET_COMMAND = 'EXTERNAL_RESET';
export const GIR_RESET_COMMAND = 'GIR_RESET';
export const NOTIFICATION_RESET_COMMAND = 'NOTIFICATION_RESET';

const resetCommandNamePaths = {
  [RESET_COMMAND]: 'ui_labels.charger/board_reset',
  [EXTERNAL_RESET_COMMAND]: 'ui_labels.charger/pwb1_reset',
  [GIR_RESET_COMMAND]: 'ui_labels.charger/gir_reset',
  [NOTIFICATION_RESET_COMMAND]: 'ui_labels.charger/notification_reset',
};

export const getFWUpdateButtonLabel = (config) => get(config, 'ui_labels.charger/fw_update', FIRMWARE_UPDATE_LABEL);

export const getResetButtons = (currentChargerData, config, userPermissions) => {
  const VENDOR_RESET_LABEL = get(config, 'ui_labels.charger/board_reset', RESET);
  const EXTERNAL_RESET_LABEL = get(config, 'ui_labels.charger/pwb1_reset', EXTERNAL_RESET);
  const GIR_RESET_LABEL = get(config, 'ui_labels.charger/gir_reset', GIR_RESET);
  const NOTIFICATION_RESET_LABEL = get(config, 'ui_labels.charger/notification_reset', NOTIFICATION_RESET);

  const pType = get(currentChargerData, uiLabelsPaths.p_type, '');

  const showResetButton = get(config, 'chargerDetails.toolbar.remoteReset.show') && hasAccess(resetBoardAccessId, userPermissions);

  const showExternalResetButton =
    get(config, 'chargerDetails.toolbar.remoteExternalReset.show') && hasAccess(resetPWB1AccessId, userPermissions);

  const showGIRResetButton =
    get(config, 'chargerDetails.toolbar.girReset.show') &&
    pType &&
    pType.toLowerCase() === get(config, 'chargerDetails.toolbar.girReset.p_type', '').toLowerCase() &&
    hasAccess(resetGIRAccessId, userPermissions);

  const showNotificationResetButton =
    get(config, 'chargerDetails.toolbar.notificationReset.show') &&
    pType &&
    pType.toLowerCase() === get(config, 'chargerDetails.toolbar.notificationReset.p_type', '').toLowerCase() &&
    hasAccess(resetNotificationsAccessId, userPermissions);

  const resetButtons = [];

  showExternalResetButton && resetButtons.push({ label: EXTERNAL_RESET_LABEL, command: EXTERNAL_RESET_COMMAND });
  showResetButton && resetButtons.push({ label: VENDOR_RESET_LABEL || RESET, command: RESET_COMMAND });
  showGIRResetButton && resetButtons.push({ label: GIR_RESET_LABEL, command: GIR_RESET_COMMAND });
  showNotificationResetButton &&
    resetButtons.push({
      label: NOTIFICATION_RESET_LABEL,
      command: NOTIFICATION_RESET_COMMAND,
    });

  return resetButtons;
};

export const getResetButtonsMenu = (resetButtons, handleRequestClose, openResetDialog, isDisabled) =>
  resetButtons
    .sort((a, b) => {
      if (a.label.toLowerCase() > b.label.toLowerCase()) {
        return 1;
      }

      if (a.label.toLowerCase() < b.label.toLowerCase()) {
        return -1;
      }

      return 0;
    })
    .map((button) => (
      <MenuItem
        key={button.label}
        disabled={isDisabled}
        onClick={() => {
          handleRequestClose();
          openResetDialog(button.command);
        }}
      >
        {button.label}
      </MenuItem>
    ));

export const getResetCommandName = (resetCommand, config) => get(config, resetCommandNamePaths[resetCommand], 'Reset');
